import React, { FunctionComponent } from 'react';
import { handleChangeHeight } from 'app/utils/helpers';
import styles from './TextareaInput.module.scss';
interface Props {
  placeholder?: string;
  label?: string;
  error?: any;
  value?: string;
  rows?: number;
  register?: any;
  name: string;
  onChange?: (value: string) => void;
  defaultValue?: string;
  noVerticalScroll?: boolean;
  disabled?: boolean;
  cols?: number;
}

const TextareaInput: FunctionComponent<Props> = ({
  placeholder,
  label,
  onChange = () => null,
  value,
  error,
  name,
  register = () => null,
  defaultValue,
  rows = 9,
  noVerticalScroll,
  disabled,
  cols,
}) => {
  return (
    <div className={styles.TextareaInput} data-testid="text-area-input">
      <div className={styles.label_required} style={{ gap: 10 }}>
        {label && (
          <label
            className={`${error ? styles.LabelError : ''} ${
              disabled ? 'labelDisabled' : ''
            }`}
          >
            {label}
          </label>
        )}
        {error && (
          <p data-testid={`${name}-error-testid`}>
            {typeof error == 'object' ? error[name]?.message : error}
          </p>
        )}
      </div>
      <textarea
        value={value}
        className={`${error ? styles.InputError : ''} ${
          noVerticalScroll ? styles.NoVerticalScroll : ''
        } ${disabled ? styles.InputDisabled : ''} `}
        disabled={disabled}
        rows={rows}
        defaultValue={defaultValue}
        placeholder={placeholder}
        data-testid={`${name}-testid`}
        onChange={(e) => onChange(e.target.value)}
        {...register(name)}
        style={cols ? { minHeight: cols } : undefined}
        onInput={handleChangeHeight}
      />
    </div>
  );
};

export default TextareaInput;
